// extracted by mini-css-extract-plugin
export default {"tableRow":"society_tableRow__zLCUC","tableCell":"society_tableCell__mwgZ7"};